const customQuoteEl = document.querySelector('.custom-quote');
// Disable Dropzone auto-discovery
window.Dropzone = window.Dropzone || {};
Dropzone.autoDiscover = false;

// ===== Main Form Class =====
class QuoteForm {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = 5;
    this.uploadedFiles = { step1: [] };
    this.form = document.getElementById('quoteForm');
    this.successMessage = document.getElementById('successMessage');
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.initializeDropzones();
    this.updateProgress();
  }

  // Event Listeners
  setupEventListeners() {
    ['nextStep1', 'nextStep2', 'nextStep3', 'nextStep4'].forEach(id => {
      document.getElementById(id).addEventListener('click', () => this.nextStep());
    });

    ['backStep2', 'backStep3', 'backStep4', 'backStep5'].forEach(id => {
      document.getElementById(id).addEventListener('click', () => this.prevStep());
    });

    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    document.getElementById('resetFormBtn').addEventListener('click', () => this.resetForm());
  }

  // Initialize Dropzone
  initializeDropzones() {
    const el = document.querySelector('#dropzoneElement');
    if (!el || el.dropzone) {
      this.dropzone1 = el?.dropzone;
      return;
    }

    const self = this;
    this.dropzone1 = new Dropzone(el, {
      url: 'https://aurastbarths.com/neonmfg/form-handler.php',
      method: 'post',
      paramName: 'files',
      maxFilesize: 20,
      maxFiles: 4,
      parallelUploads: 4,
      uploadMultiple: true,
      acceptedFiles: '.ai,.eps,.gif,.jpg,.jpeg,.pdf,.png,.tiff',
      autoProcessQueue: false,
      addRemoveLinks: true,
      dictRemoveFile: 'Remove',
      dictMaxFilesExceeded: 'You can only upload 4 files',
      dictInvalidFileType: 'Invalid file type. Allowed: ai, eps, gif, jpg, jpeg, pdf, png, tiff',
      dictFileTooBig: 'File is too big (max 20MB)',
      init: function () {

        this.on('maxfilesexceeded', function (file) {
          this.removeFile(file);
          // Silently ignore files beyond the limit - don't emit error
        });

        this.on('removedfile', (file) => {
          if (file.name) {
            self.uploadedFiles.step1 = self.uploadedFiles.step1.filter(f => f.original_name !== file.name);
          }
        });

        this.on('success', (file, responseText) => {
          try {
            const res = typeof responseText === 'string' ? JSON.parse(responseText) : responseText;
            if (res?.success && Array.isArray(res.files)) {
              res.files.forEach(f => {
                if (!self.uploadedFiles.step1.some(x => x.saved_name === f.saved_name)) {
                  self.uploadedFiles.step1.push({
                    original_name: f.original_name,
                    saved_name: f.saved_name,
                    size: f.size,
                    type: f.type || ''
                  });
                }
              });
            }
          } catch (err) {
            console.error('Failed to parse upload response:', err, responseText);
          }
        });

        this.on('error', (file, errorMessage) => {
          console.error('Upload error:', errorMessage);
        });
      }
    });
  }

  // Navigation
  nextStep() {
    if (this.validateCurrentStep()) {
      this.currentStep++;
      this.updateProgress();
      this.showStep();
      if (customQuoteEl) {
        customQuoteEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  prevStep() {
    this.currentStep--;
    this.updateProgress();
    this.showStep();
    if (customQuoteEl) {
      customQuoteEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  showStep() {
    document.querySelectorAll('.form-step').forEach(step => {
      step.classList.remove('active');
    });
    document.getElementById(`step${this.currentStep}`).classList.add('active');
  }

  updateProgress() {
    const progress = (this.currentStep / this.totalSteps) * 100;
    document.getElementById('progressFill').style.width = progress + '%';
    document.getElementById('stepIndicator').textContent = `Step ${this.currentStep} / ${this.totalSteps}`;
  }

  // Validation
  validateCurrentStep() {
    switch (this.currentStep) {
      case 1:
        return true;
      case 2:
        const details = document.getElementById('details').value.trim();
        const size = document.getElementById('signSize').value.trim();
        if (!details) { this.showError('details', 'Please share details about your sign'); return false; }
        if (!size) { this.showError('signSize', 'Please specify the sign size'); return false; }
        return true;
      case 3:
        const signType = document.querySelector('input[name="signType"]:checked');
        if (!signType) { alert('Please select whether the sign will be installed indoors or outdoors'); return false; }
        return true;
      case 4:
        const ackWrap = document.getElementById('ackWrap');
        if (ackWrap.style.display !== 'none') {
          const ackCheckbox = document.getElementById('ack');
          if (!ackCheckbox.checked) {
            this.showError('ack', 'Please acknowledge the design limitations');
            return false;
          }
        }
        return true;
      case 5:
        const postalCode = document.getElementById('postalCode').value.trim();
        const name = document.getElementById('name').value.trim();
        const email = document.getElementById('email').value.trim();
        if (!postalCode) { this.showError('postalCode', 'Please enter shipping location'); return false; }
        if (!name) { this.showError('name', 'Please enter your name'); return false; }
        if (!email) { this.showError('email', 'Please enter your email address'); return false; }
        if (!this.isValidEmail(email)) { this.showError('email', 'Please enter a valid email address'); return false; }
        return true;
      default:
        return true;
    }
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  showError(fieldId, message) {
    const field = document.getElementById(fieldId);
    if (!field) return;

    field.classList.add('error');

    const existingError = field.parentElement.querySelector('.error-message');
    if (existingError) existingError.remove();

    const errorMsg = document.createElement('span');
    errorMsg.className = 'error-message';
    errorMsg.textContent = message;
    field.parentElement.appendChild(errorMsg);

    field.addEventListener('input', () => {
      field.classList.remove('error');
      const err = field.parentElement.querySelector('.error-message');
      if (err) err.remove();
    }, { once: true });
  }

  // Form Submission
  async handleSubmit(e) {
    e.preventDefault();
    if (!this.validateCurrentStep()) return;

    const submitBtn = document.getElementById('submitBtn');
    submitBtn.classList.add('loading');
    submitBtn.disabled = true;

    try {
      const hasFiles = this.dropzone1?.getAcceptedFiles().length > 0;

      if (hasFiles) {
        const checkAndSubmit = () => {
          const files = this.dropzone1.getAcceptedFiles();
          // Only check files that are actually in the queue (not removed)
          const queuedFiles = files.filter(f => f.status !== Dropzone.CANCELED);
          const allSuccess = queuedFiles.length === 0 || queuedFiles.every(f => f.status === Dropzone.SUCCESS);

          this.dropzone1.off('queuecomplete', checkAndSubmit);

          if (!allSuccess) {
            alert('Some files failed to upload. Please check and try again.');
            submitBtn.classList.remove('loading');
            submitBtn.disabled = false;
            return;
          }

          this.submitTextFieldsOnly();
        };

        this.dropzone1.on('queuecomplete', checkAndSubmit);
        this.dropzone1.processQueue();
      } else {
        await this.submitTextFieldsOnly();
      }
    } catch (error) {
      console.error('Form submission error:', error);
      alert('An error occurred while submitting the form. Please try again.');
      submitBtn.classList.remove('loading');
      submitBtn.disabled = false;
    }
  }

  async submitTextFieldsOnly() {
    const submitBtn = document.getElementById('submitBtn');
    const formDataToSend = new FormData();

    formDataToSend.append('details', document.getElementById('details').value);
    formDataToSend.append('signSize', document.getElementById('signSize').value);
    formDataToSend.append('signType', document.querySelector('input[name="signType"]:checked').value);
    formDataToSend.append('budget', document.getElementById('budgetInput').value);
    formDataToSend.append('ack', document.getElementById('ack').checked ? 'yes' : 'no');
    formDataToSend.append('country', document.getElementById('country').value);
    formDataToSend.append('postalCode', document.getElementById('postalCode').value);
    formDataToSend.append('name', document.getElementById('name').value);
    formDataToSend.append('email', document.getElementById('email').value);
    formDataToSend.append('final_submit', '1');
    formDataToSend.append('gclid', document.querySelector('input[name="gclid"]')?.value || '');
    formDataToSend.append('fbclid', document.querySelector('input[name="fbclid"]')?.value || '');
    formDataToSend.append('utm_campaign', document.querySelector('input[name="utm_campaign"]')?.value || '');

    const savedNames = this.uploadedFiles.step1.map(f => f.saved_name).filter(Boolean);
    savedNames.forEach(name => formDataToSend.append('attachments[]', name));

    try {
      const response = await fetch('https://aurastbarths.com/neonmfg/form-handler.php', {
        method: 'POST',
        body: formDataToSend
      });
      const result = await response.json();

      if (result.success) {
        // Show success message immediately
        this.showSuccessMessage();

        // Safely call Shopify analytics
        try {
          if (typeof Shopify !== 'undefined' && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('custom_quote_form_submitted', {
              email: document.getElementById('email').value,
              name: document.getElementById('name').value,
              budget: document.getElementById('budgetInput').value,
              currency: 'USD',
              submission_id: result.submission_id || ''
            });
          }
        } catch (e) {
          console.warn('Shopify analytics not available:', e.message);
        }

        // Safely call Facebook Pixel
        try {
          if (typeof fbq === 'function') {
            fbq('trackCustom', 'custom_quote_lead');
          }
        } catch (e) {
          console.warn('Facebook Pixel not available:', e.message);
        }

        // Redirect to thank you page (1 second delay)
        this.redirectToThankYou();
      } else {
        alert('Error: ' + (result.message || 'Failed to submit form'));
      }

    } catch (error) {
      console.error('Final submit error:', error);
      alert('An error occurred while submitting the form. Please try again.');
    } finally {
      submitBtn.classList.remove('loading');
      submitBtn.disabled = false;
    }
  }

  showSuccessMessage() {
    this.form.style.display = 'none';
    this.successMessage.style.display = 'flex';
  }

  redirectToThankYou(delayMs = 1000) {
    setTimeout(() => {
      window.location.href = 'https://neonmfg.com/pages/custom-contact-thank-you';
    }, delayMs);
  }

  resetForm() {
    this.form.reset();
    this.currentStep = 1;
    this.uploadedFiles = { step1: [] };

    if (this.dropzone1) {
      this.dropzone1.removeAllFiles(true);
    }

    this.form.style.display = 'block';
    this.successMessage.style.display = 'none';
    this.updateProgress();
    this.showStep();
    if (customQuoteEl) {
      customQuoteEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

// ===== Budget Slider Configuration =====
const budgetContent = {
  '1': {
    level: '<b>⚠️ VERY BASIC DESIGNS MADE AT SMALL SIZES ONLY ⚠️</b>',
    suitable: '<b>Read me:</b> This price range is only good for very small sign sizes. Only very basic designs can be made at very small sizes. If your design is any more complex than the two example images shown, this price range will not work for you. Neon tubing has physical limits to how short it can be and how tightly it can bend. So detailed designs require more space.',
    notSuitable: ''
  },
  '2': {
    level: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg>',
    suitable: 'Small signs, short quotes, simple logos, single or dual lines, clean block letter fonts or basic script fonts, visible from short to medium distances',
    notSuitable: 'Large sign sizes, complex or highly detailed designs, complex multi-line scripts'
  },
  '3': {
    level: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg>',
    suitable: 'Medium sized signs, medium-detail logos, moderate complexity, visible from medium to long distances',
    notSuitable: 'Very large sign sizes, complex or highly detailed designs'
  },
  '4': {
    level: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg>',
    suitable: 'Large sign sizes, complex and highly detailed designs, statement pieces, visible from long distances',
    notSuitable: ''
  },
  '5': {
    level: '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><path d="M24.9001 1.56289L31.4631 14.9049L46.134 17.0449C46.686 17.1269 47.0671 17.6409 46.9851 18.1939C46.9531 18.4119 46.8501 18.6139 46.6921 18.7679L36.078 29.1509L38.584 43.8149C38.679 44.3629 38.313 44.8839 37.765 44.9799C37.546 45.0179 37.3201 44.9829 37.1231 44.8789L24.0001 37.9569L10.8771 44.8809C10.3861 45.1409 9.77705 44.9529 9.51805 44.4619C9.41405 44.2649 9.37805 44.0379 9.41705 43.8179L11.9231 29.1509L1.30505 18.7679C0.906051 18.3779 0.898051 17.7379 1.28905 17.3379C1.44305 17.1799 1.64505 17.0769 1.86305 17.0449L16.5341 14.9049L23.1001 1.56289C23.3411 1.06589 23.9391 0.857891 24.4361 1.09889C24.6391 1.19689 24.8021 1.36089 24.9001 1.56289Z" fill="url(#nc-ui-5-0_linear_207_229)"></path><defs><linearGradient id="nc-ui-5-0_linear_207_229" x1="23.9984" y1="0.998535" x2="23.9984" y2="44.9979" gradientUnits="userSpaceOnUse"><stop stop-color="#FFD36E"></stop><stop offset="1" stop-color="#F6B828"></stop></linearGradient></defs></g></svg>',
    suitable: 'Very large signs, complex and highly detailed designs, multi-piece installations, special materials/features, visible from all around',
    notSuitable: ''
  }
};

function mapRangeToBudget(val) {
  const v = Number(val);
  if (v >= 900) return '5';
  if (v >= 700) return '4';
  if (v >= 500) return '3';
  if (v >= 300) return '2';
  return '1';
}



function updateBudgetDisplay(selectedValue) {
  const imageGroups = document.querySelectorAll('.image-group');
  const notSuitableContainer = document.querySelector('.not-suitable-for');
  const dynamicContentBox = document.querySelector('.dynamic-content-box');
  const content = budgetContent[selectedValue];
  const hasNotSuitable = !!content.notSuitable && content.notSuitable.trim().length > 0;

  imageGroups.forEach(group => {
    group.classList.toggle('active', group.dataset.budget === selectedValue);
  });

  if (dynamicContentBox) {
    dynamicContentBox.classList.remove('budget1', 'budget2', 'budget3', 'budget4', 'budget5');
    dynamicContentBox.classList.add(`budget${selectedValue}`);
  }

  if (content) {
    document.getElementById('level-of-detail').innerHTML = content.level;
    document.getElementById('suitable-for').innerHTML = content.suitable;
    document.getElementById('not-suitable-for').textContent = content.notSuitable;
  }
  if (notSuitableContainer) {
    // Hide the entire container when empty
    notSuitableContainer.style.display = hasNotSuitable ? '' : 'none';
  }

}

function toggleAckWrap(budgetValue) {
  const ackWrap = document.getElementById('ackWrap');
  const ackCheckbox = document.getElementById('ack');

  if (budgetValue < 300) {
    ackWrap.style.display = 'block';
    ackCheckbox.required = true;
  } else {
    ackWrap.style.display = 'none';
    ackCheckbox.required = false;
    ackCheckbox.checked = false; // Reset checkbox when hidden
  }
}


// ===== URL Parameter Tracking =====
function getParam(p) {
  return new URLSearchParams(window.location.search).get(p);
}

function getExpiryRecord(value) {
  const expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 days
  return { value, expiryDate: Date.now() + expiryPeriod };
}

function getValidRecord(key) {
  try {
    const record = JSON.parse(localStorage.getItem(key));
    return record?.expiryDate > Date.now() ? record : null;
  } catch {
    return null;
  }
}

function prefillHiddenInputs() {
  const params = ['gclid', 'fbclid', 'utm_campaign'];
  params.forEach(param => {
    const el = document.querySelector(`input[name="${param}"]`);
    if (el) {
      const urlValue = getParam(param);
      const storedValue = getValidRecord(param);
      el.value = storedValue?.value || urlValue || '';

      if (urlValue) {
        localStorage.setItem(param, JSON.stringify(getExpiryRecord(urlValue)));
      }
    }
  });
}

// ===== Initialize on DOM Ready =====
document.addEventListener('DOMContentLoaded', () => {
  // Initialize form
  new QuoteForm();

  // Initialize budget slider
  const budgetSlider = document.getElementById('budgetSlider');
  const budgetInput = document.getElementById('budgetInput');
  const stops = Array.from(document.querySelectorAll('.budget-stops li'));
  const stopValues = stops.map(li => Number(li.dataset.val));

  noUiSlider.create(budgetSlider, {
    start: 700,
    range: { min: 200, max: 1000 },
    step: 10,
    tooltips: true,
    format: {
      to: v => Math.round(v),
      from: v => Number(v)
    }
  });

  function setActiveStop(currentValue) {
    let nearestIndex = 0;
    let minDiff = Infinity;
    stopValues.forEach((val, i) => {
      const diff = Math.abs(currentValue - val);
      if (diff < minDiff) {
        minDiff = diff;
        nearestIndex = i;
      }
    });
    stops.forEach((li, i) => li.classList.toggle('active', i === nearestIndex));
  }

  budgetSlider.noUiSlider.on('update', (values, handle, unencoded) => {
    const numeric = unencoded[0];
    budgetInput.value = Math.round(numeric);
    updateBudgetDisplay(mapRangeToBudget(numeric));
    toggleAckWrap(numeric);
    setActiveStop(numeric);
  });

  stops.forEach((li, idx) => {
    li.addEventListener('click', () => budgetSlider.noUiSlider.set(stopValues[idx]));
  });

  // Initialize display
  const initVal = budgetSlider.noUiSlider.get(true);
  const initNum = Array.isArray(initVal) ? initVal[0] : initVal;
  updateBudgetDisplay(mapRangeToBudget(initNum));
  setActiveStop(initNum);

  // Prefill tracking parameters
  prefillHiddenInputs();
});
